import React from "react";
import { Link } from "react-router-dom";

const PaymentResultPage = ({
  pageTitle,
  pageSubtitle,
  themeClass,
  iconClass,
  title,
  message,
  children,
  primaryAction,
  secondaryAction,
  shouldAnimateCard = true,
}) => (
  <div className="t-createPayment-page t-paymentResult-page" style={{ background: "#ffffff" }}>
    <div className="row" style={{ padding: "3%" }}>
      <div className="col-12">
        <div className="t-memberInfo-pageHeader">
          <h1 className="t-memberInfo-pageTitle">{pageTitle}</h1>
          {pageSubtitle ? <p className="t-memberInfo-pageSubtitle">{pageSubtitle}</p> : null}
        </div>

        <article
          className={`t-memberInfo-card ${themeClass}${
            shouldAnimateCard ? " t-memberInfo-card--enter" : ""
          }`}
        >
          <div className="t-infoSuccess-body">
            <div className="t-infoSuccess-icon">
              <i className={iconClass} aria-hidden="true" />
            </div>

            <h2 className="t-infoSuccess-title">{title}</h2>
            {message ? <p className="t-infoSuccess-message">{message}</p> : null}
            {children}
          </div>
        </article>
      </div>
    </div>
    <div className="row" style={{ height: 30 }} />
  </div>
);

export default PaymentResultPage;
